const BASE_URL = "https://api.themoviedb.org/3";
const BASE_IMAGE_URL = "http://image.tmdb.org/t/p/w500";
const HD_IMAGE_URL = "https://image.tmdb.org/t/p/original";

// MOVIE GENRE ID'S
const ACTION_MOVIE_VAL = 28;
const COMEDY_MOVIE_VAL = 35;
const ADVENTURE_MOVIE_VAL = 12;

// TV GENRE ID'S
const ANIMATION_TV_VAL = 16;
const COMEDY_TV_VAL = 35;
const SCI_FI_FANTASY_VAL = 10765;

module.exports = {
    BASE_URL,
    BASE_IMAGE_URL,
    HD_IMAGE_URL,
    ACTION_MOVIE_VAL,
    COMEDY_MOVIE_VAL,
    ADVENTURE_MOVIE_VAL,
    ANIMATION_TV_VAL,
    COMEDY_TV_VAL,
    SCI_FI_FANTASY_VAL,
};
